import React, { useEffect, useState } from "react";
import healthImg from "../../assets/images/service/health_4.png";
import HealthDescription3 from "./HealthDescription3";
import HealthDescription4 from "./HealthDescription4";
import TestApiModal from "../../component/modal/TestApiModal";
import TestAPiMobileModal from "../../component/modal/TestApiMobileModal";
import LoginModal from "../../component/modal/LoginModal";
import { handleModalController } from "../../util/Common";
import HealthDescription5 from "./HealthDescription5";
const HealthService5 = () => {
  const [showModal, setShowModal] = useState(false);
  const [showMobileModal, setShowMobileModal] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isLoginModal, setLoginModal] = useState(false);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);

    // 이벤트 리스너 등록
    window.addEventListener("resize", handleResize);

    // cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleClick = () => {
    handleModalController({
      windowWidth,
      setShowModal,
      setShowMobileModal,
      setLoginModal,
    });
  };

  return (
    <>
      <div
        className="row mb-5 sercice-details-content align-items-center"
        id="health-3"
      >
        <div className="col-lg-6 col-12 order-2 order-lg-1">
          <div className="details mt_md--30 mt_sm--30">
            <h4 className="title">건강보험공단 건강검진 내역 조회 API</h4>
            <p>
              건강보험공단 간편인증 또는 공동인증서 로그인 후 해당 사용자에 대한
              건강검진 정보를 요청합니다.
            </p>
            <ul className="liststyle mt-4">
              <li>
                건강보험공단에서 시행하는 국가건강검진 내역을 조회할 수 있음
              </li>
              <li>간편인증 및 공동인증서 인증API와 연동하여 사용</li>
            </ul>
          </div>
          <div className="slide-btn mt-4">
            <a
              className="rn-button-style--2 btn-primary-color"
              style={{
                cursor: `pointer`,
              }}
              onClick={() => handleClick()}
            >
              신청하기
            </a>
          </div>
        </div>
        <div className="col-lg-6 col-12 order-1 order-lg-2">
          <div className="thumb position-relative">
            <img className="w-100" src={healthImg} alt="Service Images" />
            {/* <ModalVideo
                    channel="youtube"
                    isOpen={this.state.isOpen}
                    videoId="ZOoVOfieAF8"
                    onClose={() => this.setState({ isOpen: false })}
                    />
                    <button
                    className="video-popup"
                    onClick={this.openModal}
                    > */}
            {/* <span className="play-icon"></span>
                    </button> */}
          </div>
        </div>
      </div>
      <HealthDescription5></HealthDescription5>
      <TestApiModal isOpen={showModal} onClose={() => setShowModal(false)} />
      <TestAPiMobileModal
        isOpen={showMobileModal}
        onClose={() => setShowMobileModal(false)}
      />
      <LoginModal isOpen={isLoginModal} onClose={() => setLoginModal(false)} />
    </>
  );
};
export default HealthService5;
